var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeInsuranceCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_a0d2af5da2ca188cfa296af4bb04291a5f21c3e723e409a1944338ed7c19341d",
    x1: 79.382,
    y1: 97.542,
    x2: 119.104,
    y2: 97.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M62.56 60.203c-7.079 0-13.553 3.035-18.519 8.027 5.947-28.984 28.336-50.512 55.047-50.512 27.165 0 49.856 22.276 55.349 51.986-5.116-5.871-12.139-9.5-19.897-9.5-6.702 0-12.875 2.727-17.726 7.257-4.851-4.53-11.025-7.257-17.726-7.257-6.985 0-13.346 2.925-18.273 7.785-4.928-4.86-11.308-7.785-18.255-7.785z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M80.815 67.988s-1.91-32.439 18.273-50.271v-7.175M116.814 67.46s2.448-31.901-17.736-49.733M99.243 121.37v2.744c0 7.475-4.757 13.554-10.628 13.554-2.926 0-5.588-1.51-7.513-3.964-1.926-2.454-3.115-5.852-3.115-9.59M99.243 73.714V60.19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M114.66 99.136l-15.414 15.421-15.421-15.421c-4.258-4.258-4.258-11.163 0-15.415 4.258-4.258 11.163-4.258 15.421 0 4.258-4.258 11.156-4.258 15.414 0 4.258 4.252 4.258 11.156 0 15.415z",
    stroke: "url(#SVGID_0_a0d2af5da2ca188cfa296af4bb04291a5f21c3e723e409a1944338ed7c19341d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_a0d2af5da2ca188cfa296af4bb04291a5f21c3e723e409a1944338ed7c19341d)",
    d: "M83.825 99.136l8.086.141 3.75-10.726 5.159 15.469 2.27-6.205 12.557.184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeInsuranceCompanies);
export default __webpack_public_path__ + "static/media/lifeInsuranceCompanies.85a7087e02b78f56274874722b4f43a7.svg";
export { ForwardRef as ReactComponent };